import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home.component";
import { NgModule } from "@angular/core";
import { SecureLayoutComponent } from "../layout/secure-layout/secure-layout.component";

const routes: Routes = [ 
    {
        path: 'home', component: SecureLayoutComponent,
        children: [
            { path: '', component: HomeComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class HomeRoutingModule { }